import React, { useEffect, useMemo, useState } from "react";

import {
    DynamicFeed,
} from "@material-ui/icons";
import DataTable from "../../../../components/data-table";
import formService from "../../../../services/form.service";
import FormAnswerUserPage from "./answer-user";

const defaultKeys = [
    {
        title: "نام",
        field: "title",
    },
];

export default function FormAnswersPage(props) {
    const { data, extra } = props

    const [uniqueAns, setUniqueAns] = useState([]);
    const [form, setForm] = useState({});

    const headerCells = useMemo(
        () => [
            {
                field: "createdDate",
                title: "تاریخ ایجاد",
                mainField: false,
            },
            {
                field: "uniqueId",
                title: "کد",
            },
        ],
        []
    );

    const onRefresh = async () => {
        const { data, error } = await formService.getUserAnswers(props.data.id);
        if (error || !data) {
            return;
        }
        setForm(data.form);
        setUniqueAns(Object.keys(data.answers).map((key) => ({
            uniqueId: key,
            createdDate: data.answers?.[key]?.[0].createdDate,
            answers: data.answers?.[key]
        })))
    };

    useEffect(() => {
        onRefresh();
    }, []);

    return (
        <div className="p-3">
            <DataTable
            order={{order: "DESC", orderBy: "createdDate"}}
                headCells={headerCells}
                data={uniqueAns}
                onRefresh={onRefresh}
                rowActions={[
                    {
                        icon: <DynamicFeed />,
                        modalProps: { fullScreen: true },
                        refreshOnClose: false,
                        modalContent: (props) => <FormAnswerUserPage {...props} form={form} />,
                    },
                ]}
                searchKeys={defaultKeys}
                title={`پاسخ های فرم  "${data.title}"`}
            />
        </div>
    );
}
